import { useNavigate } from 'react-router-dom';

export default function IntroSection() {
  const navigate = useNavigate();

  const handleReadGuide = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate('/sugargoo-spreadsheet-guide');
  };

  return (
    <section className="w-full py-14 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1">
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-5">
              Everything You Need To Know About Sugargoo Spreadsheet
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-5">
              Sugargoo Spreadsheet is a curated collection of product recommendations, shopping resources and useful information designed to help international shoppers discover products faster. Instead of spending hours searching through multiple marketplaces, users can explore organized spreadsheets containing categories, product details, guides and buying tips.
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
              Whether you are hunting for the latest sneaker releases, looking for budget-friendly clothing options, or trying to understand international shipping logistics, our spreadsheet database gives you a head start with verified finds and expert-curated recommendations.
            </p>

            <a
              href="/sugargoo-spreadsheet-guide"
              onClick={handleReadGuide}
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-secondary-500 text-background-50 text-sm font-semibold hover:bg-secondary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              Read Complete Guide
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </a>
          </div>

          <div className="flex-1 w-full">
            <div className="bg-background-100 border border-background-200/70 rounded-2xl overflow-hidden">
              <div className="grid grid-cols-2 divide-x divide-background-200/70">
                <div className="p-4 md:p-6">
                  <p className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-3">Traditional Searching</p>
                  <ul className="space-y-2.5">
                    <li className="flex items-start gap-2 text-sm text-foreground-600">
                      <i className="ri-close-circle-line text-accent-500 mt-0.5 flex-shrink-0 w-4 h-4 flex items-center justify-center"></i>
                      Hours of searching
                    </li>
                    <li className="flex items-start gap-2 text-sm text-foreground-600">
                      <i className="ri-close-circle-line text-accent-500 mt-0.5 flex-shrink-0 w-4 h-4 flex items-center justify-center"></i>
                      Random products
                    </li>
                    <li className="flex items-start gap-2 text-sm text-foreground-600">
                      <i className="ri-close-circle-line text-accent-500 mt-0.5 flex-shrink-0 w-4 h-4 flex items-center justify-center"></i>
                      No comparison
                    </li>
                    <li className="flex items-start gap-2 text-sm text-foreground-600">
                      <i className="ri-close-circle-line text-accent-500 mt-0.5 flex-shrink-0 w-4 h-4 flex items-center justify-center"></i>
                      Beginner difficulty
                    </li>
                  </ul>
                </div>
                <div className="p-4 md:p-6 bg-primary-50/50">
                  <p className="text-xs font-semibold text-primary-600 uppercase tracking-wider mb-3">Sugargoo Spreadsheet</p>
                  <ul className="space-y-2.5">
                    <li className="flex items-start gap-2 text-sm text-foreground-700">
                      <i className="ri-check-line text-primary-500 mt-0.5 flex-shrink-0 w-4 h-4 flex items-center justify-center"></i>
                      Organized database
                    </li>
                    <li className="flex items-start gap-2 text-sm text-foreground-700">
                      <i className="ri-check-line text-primary-500 mt-0.5 flex-shrink-0 w-4 h-4 flex items-center justify-center"></i>
                      Curated finds
                    </li>
                    <li className="flex items-start gap-2 text-sm text-foreground-700">
                      <i className="ri-check-line text-primary-500 mt-0.5 flex-shrink-0 w-4 h-4 flex items-center justify-center"></i>
                      Easy comparison
                    </li>
                    <li className="flex items-start gap-2 text-sm text-foreground-700">
                      <i className="ri-check-line text-primary-500 mt-0.5 flex-shrink-0 w-4 h-4 flex items-center justify-center"></i>
                      Beginner friendly
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}